import {
  DELETE_PRACTICE_LIST,
  DELETE_PRACTICE_LIST_SUCCESS,
  DELETE_PRACTICE_LIST_FAILURE,
} from 'store/practiceDetelet/practiceDeleteAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const deletePracticeListReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_PRACTICE_LIST:
      return { ...state, loading: true };
    case DELETE_PRACTICE_LIST_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case DELETE_PRACTICE_LIST_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default deletePracticeListReducer;
